module.exports = __webpack_public_path__ + "static/media/Emblem_Iron.37ae9f9d.png";